module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point03_01_winter-15220ff5c83823507f8b0f36e03a8370.jpg";